// extracted by mini-css-extract-plugin
export default {"container":"Language_container__c1Qp+","menu":"Language_menu__YBZj7","item":"Language_item__xK1nS"};